module.exports = __webpack_public_path__ + "img/chart-21.b064ce14.svg";